<script>
import utils from '@/utils/common';

import TaskViewMembersPopup from '@/components/task/view/TaskViewMembersPopup.vue';

export default {
  name: 'TaskViewUsersDispatcher',
  components: { TaskViewMembersPopup },
  data() {
    return {
      value: {
        selectedUsers: [],
        selectedUser: null,
      },
    };
  },
  props: {
    action: String,
    tasks: Array,
    isOpened: Boolean,
    mode: String,
  },
  computed: {
    possibleUsersIntersection() {
      const selectedProjects = {};

      this.tasks.forEach(i => {
        selectedProjects[i.project.id] = i.project;
      });

      const usersGrouped = Object.values(selectedProjects).map(p => new Set([p.author.id, ...p.projectMembers.map(m => m.user.id)]));
      let res = [...usersGrouped[0]];

      for (let i = 1; i < usersGrouped.length; i += 1) {
        res = res.filter((x) => usersGrouped[i].has(x));
      }

      const usersById = Object.values(selectedProjects)
        .map(p => [p.author, ...p.projectMembers.map(m => m.user)])
        .reduce((acc, value) => [...acc, ...value], [])
        .reduce((acc, value) => ({ ...acc, [value.id]: value }), {});

      return res.map(id => usersById[id]);
    },

    changedTasksWord() {
      return utils.pluralWord(this.tasks.length, 'задаче', 'задачах', 'задачах');
    },

    isMultiple() {
      return this.action === 'members' || this.action === 'deleteParticipants' || this.action === 'deleteMembers';
    },

    props() {
      return {
        multiple: this.isMultiple,
        users: this.possibleUsersIntersection,
        header: this.headers[this.action],
        action: this.action,
        mode: this.mode,
      };
    },

    question() {
      let membersQuestion = '';
      const deleteMembersQuestion = `Вы действительно хотите удалить выбранных наблюдателей в ${this.changedTasksWord}? Эту операцию невозможно отменить.`;
      const deleteParticipantsQuestion = `Вы действительно хотите удалить выбранных участников в ${this.changedTasksWord}? Эту операцию невозможно отменить.`;

      if (this.mode === 'add' && this.value.selectedUsers.length) {
        membersQuestion = `Вы действительно хотите добавить наблюдателей в ${this.changedTasksWord}? Эту операцию невозможно отменить.`;
      }
      return {
        author: this.value.selectedUser
          ? `Вы действительно хотите установить автора в ${this.changedTasksWord}? Эту операцию невозможно отменить.`
          : 'Не выбрано ни одного участника на роль автора. Вернуться к списку задач?',
        manager: this.value.selectedUser
          ? `Вы действительно хотите установить исполнителя в ${this.changedTasksWord}? Эту операцию невозможно отменить.`
          : `Вы действительно хотите удалить исполнителя в ${this.changedTasksWord}? Эту операцию невозможно отменить.`,
        members: membersQuestion,
        deleteMembers: deleteMembersQuestion,
        deleteParticipants: deleteParticipantsQuestion,
      };
    },

    headers() {
      return {
        author: 'Установить автора',
        manager: 'Установить исполнителя',
        members: 'Добавить наблюдателей',
        deleteParticipants: 'Удалить участников',
        deleteMembers: 'Удалить наблюдателей',
      };
    },
  },
  methods: {
    isSelectedExternal(user) {
      return this.isMultiple
        ? this.value.selectedUsers.includes(user['@id'])
        : this.value.selectedUser === user['@id'];
    },

    toggleSelectedUsers(user) {
      if (this.isSelectedExternal(user)) {
        this.uncheck(user);
      } else {
        this.check(user);
      }
    },

    check(user) {
      if (this.isMultiple) {
        this.value.selectedUsers = [...this.value.selectedUsers, user['@id']];
      } else {
        this.value.selectedUser = user['@id'];
      }
    },

    uncheck(user) {
      if (this.isMultiple) {
        this.value.selectedUsers = this.value.selectedUsers.filter((u) => u !== user['@id']);
      } else {
        this.value.selectedUser = null;
      }
    },

    async submit(boolean) {
      const value = this.isMultiple
        ? this.value.selectedUsers
        : this.value.selectedUser;

      let text;
      const params = { result: { [this.action]: value }, onSuccess: () => { this.$push({ text }); } };

      if (!boolean) {
        this.$emit('close');
      } else {
        switch (this.action) {
          case 'members':
            text = value.length ? 'Наблюдатели установлены' : 'Наблюдатели удалены';

            if (this.mode === 'add' && value.length) {
              text = 'Наблюдатели добавлены';
            }

            if (await this.$confirm(this.question[this.action])) {
              this.$emit('submit', params);
            }
            break;
          case 'manager':
            text = value ? 'Исполнетель установлен' : 'Исполнетель удален';

            if (await this.$confirm(this.question[this.action])) {
              this.$emit('submit', params);
            }
            break;
          case 'author':
            if (await this.$confirm(this.question[this.action])) {
              if (value) {
                text = 'Автор установлен';

                this.$emit('submit', params);
              } else {
                this.$emit('close');
              }
            }
            break;
          case 'deleteMembers':
            if (await this.$confirm(this.question[this.action])) {
              if (value) {
                text = 'Выбранные наблюдатели удалены';

                this.$emit('submit', params);
              } else {
                this.$emit('close');
              }
            }
            break;
          case 'deleteParticipants':
            if (await this.$confirm(this.question[this.action])) {
              if (value) {
                text = 'Выбранные участники удалены';

                this.$emit('submit', params);
                console.log(params);
              } else {
                this.$emit('close');
              }
            }
            break;
          default:
            this.$emit('close');
            break;
        }

        this.value.selectedUsers = [];
        this.value.selectedUser = null;
      }
    },
  },
};
</script>

<template lang="pug">
TaskViewMembersPopup(v-if="isOpened" v-bind="props" v-model="value" @change="toggleSelectedUsers" @submit="submit")
</template>

<style scoped lang="scss">

</style>
